import PromotionLabel from 'LuxKit/Label/PromotionLabel'
import useAgentHubCommissionLabel from 'agentHub/hooks/useAgentHubCommissionLabel'
import { isAgentHubEnabled } from 'agentHub/selectors/isAgentHubEnabled'
import { useAppSelector } from 'hooks/reduxHooks'
import { useIntl } from 'react-intl'

interface Props {
  offerId: string | undefined
  packageId?: string | undefined
}

/**
 * Displays an additional commission label when commission data is available for an offer
 * @param offerId - The offer ID to check commission for
 * @param packageId - Optional package ID for package-specific commission
 */
function AgentHubAdditionalCommissionLabel({ offerId, packageId }: Props) {
  const intl = useIntl()
  const customerView = useAppSelector(state => state.agentHub.customerView)
  const { showCommissionLabel, additionalCommissionPercentage } = useAgentHubCommissionLabel(offerId, packageId)

  if (!isAgentHubEnabled || customerView) {
    return null
  }

  if (!showCommissionLabel) {
    return null
  }

  return (
    <PromotionLabel>
      {intl.formatMessage({
        id: 'Mda_2HqsTooqONILGNr1',
        defaultMessage: 'Includes additional {additionalCommissionPercentage}% commission',
      }, {
        additionalCommissionPercentage,
      })}
    </PromotionLabel>
  )
}

export default AgentHubAdditionalCommissionLabel
